import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { RealTimeCaptionsComponent } from './real-time-captions.component';

export const ngxRealTimeCaptionsModule = angular.module('ngxRealTimeCaptionsModule', [])
	.directive('ngxRealTimeCaptions', downgradeComponent({ component: RealTimeCaptionsComponent }))
	.name;
